import React from 'react'
import { Button } from '@material-ui/core'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import InstallationImagesModal from './InstallationImagesModal'
import { entriesToState, stateToEntries } from './installationImageUtils'

/**
 * Document upload block for vehicle registration and edit.
 * Reads/writes the same state the payload already uses: fileNames + documentUploadNewData.
 */
const InstallationImagesSection = ({ client, fileNames, documentUploadNewData, vehicleSolutionType, mode, onChange, errorMessage, required }) => {
  const [open, setOpen] = React.useState(false)
  const entries = stateToEntries(fileNames, documentUploadNewData)
  const counts = {}
  entries.forEach(entry => {
    const key = entry.solutionType || 'Unassigned'
    counts[key] = (counts[key] || 0) + 1
  })
  const summary = Object.keys(counts).map(key => [key, counts[key]])

  const handleSave = newEntries => {
    onChange(entriesToState(newEntries))
    setOpen(false)
  }

  return (
    <div style={{ marginTop: '15px', padding: '10px', border: '1px solid #eee' }}>
      <label>
        Installation Images{required ? ' *' : ''}{' '}
        <small>(JPEG, JPG, PNG or PDF up to 30 Mb)</small>
      </label>
      <div style={{ marginTop: '10px' }}>
        <Button variant="outlined" color="primary" style={{ fontWeight: 'bold' }} onClick={() => setOpen(true)}>
          <CloudUploadIcon style={{ fontSize: 18, marginRight: 6 }} />
          {entries.length ? 'Manage Images' : 'Upload Images'}
        </Button>
        <small style={{ marginLeft: 10, color: '#757575' }}>{entries.length} image(s)</small>
      </div>
      {/* Compact summary — TMA vehicles can carry 80+ images; the full list lives in the modal */}
      {summary.length > 0 && (
        <div style={{ marginTop: '6px', fontSize: 12, color: '#757575' }}>
          {summary.map(([solution, count]) => `${solution}: ${count}`).join(' · ')}
        </div>
      )}
      {errorMessage && <div style={{ color: '#d32f2f', fontSize: 12, marginTop: 6 }}>{errorMessage}</div>}
      {open && (
        <InstallationImagesModal
          open={open}
          onClose={() => setOpen(false)}
          onSave={handleSave}
          client={client}
          entries={entries}
          vehicleSolutionType={vehicleSolutionType}
          mode={mode}
        />
      )}
    </div>
  )
}

export default InstallationImagesSection



// WEBPACK FOOTER //
// ./src/components/Modules/VehicleRegistartion/InstallationImagesSection.jsx